// English translations for tours
export const tourTranslations = {
  1: {
    title: "Classic Saona Island",
    description: "Saona Island is part of the East National Park, a tropical paradise with white sand beaches and crystal clear turquoise waters. An unforgettable experience sailing through the Caribbean Sea.",
    duration: "1 Day",
    transport: "Round Trip",
    includes: [
      "Round trip transportation from your hotel",
      "Spanish-speaking tour guide",
      "Speedboat and catamaran navigation",
      "Stop at Natural Pool with starfish",
      "Beach buffet lunch",
      "Open bar (rum, beer, soft drinks, water)",
      "Snorkeling in the Caribbean Sea",
      "Dominican music and entertainment on board",
      "2.5 hours on the beach (approximately)"
    ],
    schedule: [
      { title: "Hotel pickup", desc: "We pick you up at your hotel and head to the village of Bayahíbe (approx. 1 hour)." },
      { title: "Natural Pool", desc: "Stop to swim with giant starfish and typical Dominican toast." },
      { title: "Saona Island", desc: "Free time to enjoy the paradise beach, swim and relax." },
      { title: "Buffet Lunch", desc: "Delicious Dominican lunch with rice, chicken, pork, salads and drinks." },
      { title: "Catamaran Return", desc: "Return trip with music, dancing and drinks included." }
    ],
    recommendations: "Swimsuit, sandals, sunglasses, cap, sunscreen, towel, cash for tips"
  },
  2: {
    title: "Santo Domingo - City Tour",
    description: "Visit the oldest capital of the New World. Santo Domingo offers history, culture and Spanish colonial architecture in every corner of its Colonial Zone, a World Heritage Site.",
    duration: "Full Day",
    transport: "Round Trip",
    includes: [
      "Round trip transportation in A/C bus",
      "Professional tour guide",
      "Colonial Zone walking tour",
      "Visit to Alcázar de Colón",
      "Primada Cathedral of America",
      "Las Damas Street",
      "Typical Dominican lunch",
      "Free time for shopping"
    ],
    schedule: [
      { title: "Departure from Punta Cana", desc: "Pickup at your hotel early in the morning." },
      { title: "Colonial Zone", desc: "Guided tour through historic streets and monuments." },
      { title: "Lunch", desc: "Typical Dominican food at a local restaurant." },
      { title: "Free time", desc: "Shopping and exploration on your own." },
      { title: "Return", desc: "Return to your hotel in Punta Cana." }
    ],
    recommendations: "Comfortable clothing, walking shoes, camera, cash for shopping"
  },
  3: {
    title: "Catalina Island",
    description: "Catalina Island is famous for its coral reefs and crystal clear waters perfect for snorkeling. A small paradise island with virgin beaches ideal for a day of adventure.",
    duration: "1 Day",
    transport: "Round Trip",
    includes: [
      "Round trip transportation",
      "Catamaran navigation",
      "Snorkeling equipment",
      "Beach buffet lunch",
      "Drinks included",
      "Bilingual guide",
      "Music and entertainment"
    ],
    schedule: [
      { title: "Pickup", desc: "Departure from your hotel to La Romana port." },
      { title: "Navigation", desc: "Catamaran trip to Catalina Island." },
      { title: "Snorkeling", desc: "Explore the coral reef with equipment included." },
      { title: "Beach and lunch", desc: "Free time on the beach and buffet lunch." },
      { title: "Return", desc: "Sail back and transportation to your hotel." }
    ],
    recommendations: "Swimsuit, towel, biodegradable sunscreen, waterproof camera"
  },
  4: {
    title: "Saona Island VIP - Exclusive Experience",
    description: "Experience Saona Island like very few do. A VIP, private, and well-organized tour designed for those seeking comfort, exclusivity and quality time at every stop. Private speedboat, small groups, no waiting, no crowds. Departures: Monday, Wednesday and Friday.",
    duration: "1 Day",
    transport: "Private Speedboat",
    includes: [
      "Round trip transportation from your hotel",
      "Private VIP speedboat",
      "Visit to 5 paradise beaches",
      "Natural Pool (exclusive area) with starfish",
      "Mangrove tour (turtles and manta rays)",
      "Catuano Beach (virgin beach)",
      "Playa del Toro (turquoise waters)",
      "Mano Juan Beach + Mano Juan Village",
      "Water, Rum, Coca-Cola, Beer",
      "Beach buffet lunch",
      "Life jackets",
      "Personalized guide and assistance"
    ],
    schedule: [
      { title: "Pickup (7:00-8:00 AM)", desc: "Transportation from your hotel. Punctuality required." },
      { title: "Natural Pool", desc: "Crystal clear waters, starfish, private atmosphere." },
      { title: "Mangroves", desc: "Turtle and manta ray sightings." },
      { title: "Catuano Beach", desc: "Virgin beach ideal for photos." },
      { title: "Playa del Toro", desc: "Turquoise waters and free time." },
      { title: "Mano Juan", desc: "Visit to the typical village and buffet lunch." }
    ],
    recommendations: "Punctuality mandatory. Swimsuit, towel, sunscreen, camera. The boat leaves at the scheduled time. Limited availability per day."
  },
  5: {
    title: "Catalina Island Diving",
    description: "Discover the underwater world of Catalina Island with this diving excursion. Coral reefs, tropical fish and a unique experience under the Caribbean Sea.",
    duration: "Full Day",
    transport: "Round Trip",
    includes: [
      "Round trip transportation",
      "Complete diving equipment",
      "PADI certified instructor",
      "2 dives",
      "Lunch included",
      "Drinks",
      "Diving insurance"
    ],
    schedule: [
      { title: "Pickup", desc: "Early departure from your hotel." },
      { title: "Briefing", desc: "Safety instructions and preparation." },
      { title: "First dive", desc: "Diving in the coral reef." },
      { title: "Rest and lunch", desc: "Time to eat and recover energy." },
      { title: "Second dive", desc: "Exploration of another area of the reef." }
    ],
    recommendations: "Diving certification required or beginner course available"
  },
  6: {
    title: "Macao Buggies",
    description: "Buggy adventure through the fields and beaches of Macao. Drive your own buggy on dirt roads, visit a coffee plantation and end at the beautiful Macao Beach.",
    duration: "4 Hours",
    transport: "Round Trip",
    includes: [
      "Round trip transportation",
      "Buggy for 2 people",
      "Expert guide",
      "Helmet and protective goggles",
      "Visit to coffee and cocoa plantation",
      "Coffee and chocolate tasting",
      "Time at Macao Beach",
      "Photos and videos of the tour"
    ],
    schedule: [
      { title: "Pickup", desc: "We pick you up at your hotel." },
      { title: "Instructions", desc: "Safety briefing and buggy operation." },
      { title: "Off-Road Adventure", desc: "Tour through dirt roads and fields." },
      { title: "Plantation", desc: "Visit and tasting of coffee and chocolate." },
      { title: "Macao Beach", desc: "Free time at the most beautiful beach." }
    ],
    recommendations: "Clothes that can get dirty, closed shoes, sunglasses, sunscreen"
  },
  7: {
    title: "Bávaro Canopy Zip Lines",
    description: "Fly over the tropical jungle of Punta Cana on the most exciting zip lines in the Caribbean. 12 different cables with spectacular views of Dominican vegetation.",
    duration: "4 Hours",
    transport: "Round Trip",
    includes: [
      "Round trip transportation",
      "12 different zip lines",
      "Complete safety equipment",
      "Certified guides",
      "Refreshing drinks",
      "Tour photos",
      "Accident insurance"
    ],
    schedule: [
      { title: "Pickup", desc: "Transportation from your hotel." },
      { title: "Equipment", desc: "Harness and safety equipment fitting." },
      { title: "Zip lines", desc: "Tour through 12 zip lines over the jungle." },
      { title: "Break", desc: "Drinks and snacks included." },
      { title: "Return", desc: "Transportation back to the hotel." }
    ],
    recommendations: "Comfortable clothes, closed shoes, no loose objects"
  },
  8: {
    title: "Imagine Disco Punta Cana - The Cave",
    description: "The most famous nightclub in the Caribbean, built inside a 10,000-year-old natural cave. Three different environments with Latin, electronic and reggaeton music.",
    duration: "5 Hours",
    transport: "Round Trip",
    includes: [
      "Round trip transportation",
      "Club admission",
      "Access to all 3 caves/environments",
      "One welcome drink",
      "VIP access available"
    ],
    schedule: [
      { title: "Night pickup", desc: "We pick you up at your hotel around 10 PM." },
      { title: "Arrival", desc: "Entry to the most spectacular cave in the Caribbean." },
      { title: "Party", desc: "Dance all night in 3 different environments." },
      { title: "Return", desc: "Transportation back when the party ends." }
    ],
    recommendations: "Smart casual dress code, 18+ only, ID required"
  },
  9: {
    title: "Dolphin Explorer",
    description: "Live a unique experience with dolphins. We have three different activities for you. All include a sea lion kiss and bird entrance.",
    duration: "40-60 minutes",
    transport: "Round Trip",
    includes: [
      "Round trip transportation from your hotel",
      "Sea lion kiss",
      "Bird entrance",
      "Professional guide",
      "Safety equipment"
    ],
    schedule: [
      { title: "Pickup", desc: "We pick you up at your hotel." },
      { title: "Park arrival", desc: "Safety instructions and preparation." },
      { title: "Dolphin activity", desc: "Interaction or swim according to chosen program." },
      { title: "Sea lion and birds", desc: "Sea lion kiss and bird visit." },
      { title: "Return", desc: "Transportation back to hotel." }
    ],
    recommendations: "Bring swimsuit, towel and sunscreen.",
    activities: [
      {
        name: "Interaction with 1 Dolphin",
        duration: "40 minutes",
        description: "40 minutes of direct contact with the dolphin. Children under 1 meter free. Pregnant women can participate."
      },
      {
        name: "Swim with 1 Dolphin",
        duration: "50 minutes",
        description: "50 minutes swimming with the dolphin. Not suitable for pregnant women or children under 1 meter."
      },
      {
        name: "Swim with 2 Dolphins",
        duration: "60 minutes",
        description: "60 minutes swimming with 2 dolphins simultaneously. Not suitable for pregnant women or children under 1 meter."
      }
    ]
  },
  12: {
    title: "Adventure Buggies Macao - Private Cave + Taíno Show",
    description: "A unique off-road adventure that includes a visit to Domitai Park, Taíno cultural show, tasting of typical products and time to swim in a private cave (cenote) with crystal clear waters.",
    duration: "4-5 Hours",
    transport: "Round Trip",
    includes: [
      "Round trip transportation from hotel",
      "Buggy for the entire tour",
      "Professional guide during excursion",
      "Off-road trails tour",
      "Mud trails and natural landscapes",
      "Visit to Domitai Park",
      "Taíno cultural show",
      "Explanation of Taíno history and traditions",
      "Tasting of Coffee, Cocoa/Chocolate and Mamajuana",
      "Visit and time to swim in private cave (cenote)",
      "Safety equipment (helmet)",
      "Water during the tour"
    ],
    schedule: [
      { title: "Pickup", desc: "We pick you up at your hotel." },
      { title: "Off-Road Adventure", desc: "Buggy ride through dirt and mud trails." },
      { title: "Domitai Park", desc: "Taíno show and tasting of typical products." },
      { title: "Private Cave", desc: "Time to swim in the crystal clear cenote." },
      { title: "Return", desc: "Transportation back to hotel." }
    ],
    recommendations: "Clothes that can get dirty, closed shoes, swimsuit, towel, sunscreen."
  },
  13: {
    title: "Deep Sea Fishing",
    description: "Embark on an adventure-filled trip and deep sea fishing like an expert. Sail through the crystal clear waters of the Dominican Caribbean and enjoy an unforgettable fishing experience in the purest Punta Cana style. Are you going to miss it?",
    duration: "Half Day",
    transport: "Round Trip",
    includes: [
      "Round trip transportation from your hotel",
      "Fishing materials",
      "Snacks",
      "Water",
      "Sodas (Coca-Cola, Pepsi, 7up)",
      "Rum",
      "Expert captain and crew"
    ],
    schedule: [
      { title: "Pickup", desc: "We pick you up at your hotel early." },
      { title: "Boarding", desc: "Departure from port to deep waters." },
      { title: "Fishing", desc: "Hours of fishing with professional equipment included." },
      { title: "Snacks", desc: "Enjoy drinks and snacks on board." },
      { title: "Return", desc: "Sail back and transportation to hotel." }
    ],
    recommendations: "Comfortable clothes, cap, sunglasses, sunscreen. Motion sickness medicine recommended if susceptible."
  },
  14: {
    title: "Coco Bongo Show & Disco",
    description: "The most famous nightclub in the Caribbean. Coco Bongo is known for its high-energy performances, spectacular shows and unforgettable entertainment. Both packages include round trip transportation from your hotel.",
    duration: "All night",
    transport: "Round Trip",
    includes: [
      "Round trip transportation from your hotel",
      "Coco Bongo admission",
      "Open bar all night",
      "Spectacular show included"
    ],
    schedule: [
      { title: "Pickup", desc: "We pick you up at your hotel at night." },
      { title: "Arrival", desc: "Entry to the most famous club in the Caribbean." },
      { title: "Show", desc: "Enjoy the unique high-energy show." },
      { title: "Party", desc: "Dance all night with open bar." },
      { title: "Return", desc: "Transportation back when it ends." }
    ],
    recommendations: "Smart casual dress code, 18+ only, ID required.",
    activities: [
      {
        name: "Premium Package",
        duration: "All night",
        description: "Premium open bar with top-shelf drinks. Personalized service with dedicated waiter. Reserved seats with best show view (2nd or 3rd level). Priority entry, no lines."
      },
      {
        name: "Regular Package",
        duration: "All night",
        description: "Open bar with unlimited standard drinks. Light snacks included. Main floor view (standing). Option to purchase table upon arrival (subject to availability)."
      }
    ]
  },
  16: {
    title: "Horseback Riding - Macao Beach",
    description: "Come and live this horseback riding adventure where you can go to Macao Beach, take a dip and enjoy a horseback ride along the beach and rural trails.",
    duration: "3 Hours",
    transport: "Round Trip",
    includes: [
      "Round trip transportation from your hotel",
      "Horse for the tour",
      "Expert guide",
      "Rural trail ride",
      "Macao Beach ride",
      "Time to swim at the beach"
    ],
    schedule: [
      { title: "Pickup", desc: "We pick you up at your hotel." },
      { title: "Ranch arrival", desc: "Instructions and horse assignment." },
      { title: "Ride", desc: "Horseback riding through rural trails to the beach." },
      { title: "Macao Beach", desc: "Free time to swim and enjoy." },
      { title: "Return", desc: "Horseback ride back and transportation to hotel." }
    ],
    recommendations: "Long pants, closed shoes, sunscreen, swimsuit. Times: 8:30 AM, 10:30 AM and 2:30 PM."
  },
  17: {
    title: "Monkey Land - Land of the Monkeys",
    description: "Observe squirrel monkeys in their natural habitat deep in the Dominican Republic jungle. Visit the monkey sanctuary and botanical gardens, learn about local coffee and cocoa plantations, and feed 20 monkeys that have been raised to be comfortable around people.",
    duration: "Half Day",
    transport: "Round Trip",
    includes: [
      "Round trip transportation from your hotel",
      "Water and fruits",
      "Feed the monkeys",
      "Walk inside the park",
      "Visit to coffee and cocoa plantation",
      "Coffee and hot chocolate tasting",
      "Botanical gardens",
      "Professional guide"
    ],
    schedule: [
      { title: "Pickup", desc: "We pick you up at your hotel (shared transport)." },
      { title: "Sanctuary arrival", desc: "Welcome and orientation." },
      { title: "Plantations", desc: "Visit to coffee and cocoa plantations with tasting." },
      { title: "Monkeys", desc: "Interaction and feeding of squirrel monkeys." },
      { title: "Botanical garden", desc: "Tour of native plants and flowers." },
      { title: "Return", desc: "Transportation back to hotel." }
    ],
    recommendations: "Comfortable shoes, camera, cash for souvenirs. Not recommended for pregnant women. Not suitable for people with severe peanut allergies. Participants with cold or flu will not be able to interact with monkeys."
  }
};

// Function to get translated tour data
export const getTranslatedTour = (tour, language) => {
  if (language === 'es') return tour;
  
  const translation = tourTranslations[tour.id];
  if (!translation) return tour;
  
  return {
    ...tour,
    title: translation.title || tour.title,
    description: translation.description || tour.description,
    duration: translation.duration || tour.duration,
    transport: translation.transport || tour.transport,
    includes: translation.includes || tour.includes,
    schedule: translation.schedule || tour.schedule,
    recommendations: translation.recommendations || tour.recommendations,
    activities: tour.activities ? tour.activities.map((activity, index) => ({
      ...activity,
      name: translation.activities?.[index]?.name || activity.name,
      description: translation.activities?.[index]?.description || activity.description,
      duration: translation.activities?.[index]?.duration || activity.duration
    })) : undefined
  };
};
